module.exports = __webpack_public_path__ + "static/media/icn-add-participant-24px-24px-blue.7698f7bf.svg";